import Config from "assets/config.json"
import { configKey } from "components/configs/Common"

export const auth0Config = Config[configKey]?.auth0

if (process.env.AUTH0_DISABLED === "True") auth0Config.disabled = true

export const disabledAuth = auth0Config?.disabled ?? false
